// @ah/books shared GraphQL queries — used by desktop and mobile.

export const RECOMMENDED_BOOKS_QUERY = /* GraphQL */ `
  query RecommendedBooks {
    recommendedBooks(limit: 20) {
      id
      olKey
      title
      subtitle
      firstPublishYear
      coverUrl
      authors { name }
      summary {
        status
        hook
        readingMinutesEst
        themes
        chapters { title }
      }
    }
  }
`;

export const BOOKS_LIST_QUERY = /* GraphQL */ `
  query BooksList {
    books(limit: 60) {
      id
      olKey
      title
      subtitle
      firstPublishYear
      coverUrl
      authors { name }
      summary {
        status
        hook
        readingMinutesEst
        themes
        modelUsed
        chapters { title }
      }
    }
  }
`;

export const BOOK_DETAIL_QUERY = /* GraphQL */ `
  query BookDetail($olKey: String!) {
    book(olKey: $olKey) {
      id
      olKey
      title
      subtitle
      description
      firstPublishYear
      coverUrl
      authors { id name photoUrl bio }
      summary {
        status
        hook
        youllLikeThisIf
        themes
        chapters { title keyTakeaway }
        readingMinutesEst
        modelUsed
        promptVersion
        generatedAt
      }
      isSaved
    }
  }
`;

const BOOK_LIST_FIELDS = /* GraphQL */ `
  id
  olKey
  title
  subtitle
  firstPublishYear
  coverUrl
  authors { name }
  summary {
    status
    hook
    readingMinutesEst
    themes
    chapters { title }
  }
`;

export const RECENTLY_READ_BOOKS_QUERY = /* GraphQL */ `
  query RecentlyReadBooks($limit: Int) {
    recentlyReadBooks(limit: $limit) { ${BOOK_LIST_FIELDS} }
  }
`;

export const SAVED_BOOKS_QUERY = /* GraphQL */ `
  query SavedBooks($limit: Int) {
    savedBooks(limit: $limit) { ${BOOK_LIST_FIELDS} }
  }
`;

export const RECORD_BOOK_ENGAGEMENT_MUTATION = /* GraphQL */ `
  mutation RecordBookEngagement($id: ID!) {
    recordBookEngagement(id: $id)
  }
`;

export const RECORD_BOOK_SAVE_MUTATION = /* GraphQL */ `
  mutation RecordBookSave($id: ID!) {
    recordBookSave(id: $id)
  }
`;

export const RECORD_BOOK_UNSAVE_MUTATION = /* GraphQL */ `
  mutation RecordBookUnsave($id: ID!) {
    recordBookUnsave(id: $id)
  }
`;

export const BOOK_PROGRESS_QUERY = /* GraphQL */ `
  query BookProgress($olKey: String!) {
    bookProgress(olKey: $olKey) {
      olKey
      chaptersRead
    }
  }
`;

export const BOOK_PROGRESS_MANY_QUERY = /* GraphQL */ `
  query BookProgressMany($olKeys: [String!]!) {
    bookProgressMany(olKeys: $olKeys) {
      olKey
      chaptersRead
    }
  }
`;

export const RECORD_BOOK_CHAPTER_READ_MUTATION = /* GraphQL */ `
  mutation RecordBookChapterRead($olKey: String!, $chapter: Int!) {
    recordBookChapterRead(olKey: $olKey, chapter: $chapter) {
      olKey
      chaptersRead
    }
  }
`;

export const BOOK_READER_QUERY = /* GraphQL */ `
  query BookReader($olKey: String!) {
    book(olKey: $olKey) {
      id
      olKey
      title
      authors { id name }
      summary {
        status
        chapters {
          title
          keyTakeaway
          blocks { kind body source }
        }
      }
    }
  }
`;
